import '../../public/css/style.css';
$(function() {
    $('.animate').on('click', function(e) {
        e.preventDefault();
        var hash = this.hash;
        $('html, body').animate({
            scrollTop: $(this.hash).offset().top
        }, 500, function(){
            window.location.hash = hash;
        });
    });
});

